import React from "react";
import styles from "./Expertise.module.scss";
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import NrgPage from '../NrgPage.jsx';
import GenericHeader from './../../components/Header/GenericHeader.jsx';
import JourneyContinueBox from './../../components/JourneyContinueBox/JourneyContinueBox.jsx';
import PipedContentHeader from './../../components/PipedContentHeader/PipedContentHeader.jsx';
import UnderPipePanel from './../../components/UnderPipePanel/UnderPipePanel.jsx';
import PipedContentFooter from './../../components/PipedContentFooter/PipedContentFooter.jsx';
import LargeIconListPanel from './../../components/LargeIconListPanel/LargeIconListPanel.jsx';
import MapStatsPanel from './../../components/MapStatsPanel/MapStatsPanel.jsx';
import ClientListPanel from './../../components/ClientListPanel/ClientListPanel.jsx';
import CompanyHistoryPanel from './../../components/CompanyHistoryPanel/CompanyHistoryPanel.jsx';
import Footer from './../../components/Footer/Footer.jsx';
import PageTransitioner from '../../components/PageTransitioner.jsx';

import ScrollItemManager from './../../utils/ScrollItemManager';
import { changePageTitle } from "../../utils/pageSetup/pageSetup";

class Expertise extends NrgPage {
    constructor(props) {
        super(props);

        this.page = 'expertise';
    }
    componentDidMount() {
        changePageTitle(this.page);

        this.scrollItemManager = new ScrollItemManager();
        this.scrollItemManager.setup();
    }
    render() {
        return (
            <div className={[this.page, "container-fluid"].join(" ")}>
                <PageTransitioner page={this.page}>

                    <GenericHeader page={this.page} newsActions={this.newsActions} />

                    <PipedContentHeader page={this.page} />
                    <UnderPipePanel page={this.page} section="content" />
                    <LargeIconListPanel page={this.page} section="content" />
                    <UnderPipePanel page={this.page} section="interactive" />
                    <LargeIconListPanel page={this.page} section="interactive" />
                    <UnderPipePanel page={this.page} section="platform" />
                    <LargeIconListPanel page={this.page} section="platform" isLast={true} />
                    <PipedContentFooter />

                    <UnderPipePanel page={this.page} section="brand" noPipes={true} />
                    <LargeIconListPanel page={this.page} section="brand" noPipes={true} />

                    <MapStatsPanel page={this.page} />

                    <ClientListPanel page={this.page} />

                    <CompanyHistoryPanel page={this.page} />

                    <JourneyContinueBox nextPage="People" nextPageHref="/people" />
                    <Footer />
                </PageTransitioner>
            </div>
        );
    }
}

export default Expertise;
